import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  searchWeeklyMeal,
  addOrEditFood,
  deleteFood,
  fetchExistDatasOfYear,
  onResetChosenDate,
  onResetScrollNum,
} from "../../../../features/mobile/mealSlice";
import { checkQuestionsComplete } from "../../../../features/mobile/otherSlice";
import dayjs from "dayjs";
import "dayjs/locale/en";
import { toast } from "react-toastify";
import toastCommonProps from "../../../../common/toast";
import HeadCont from "../../components/common/HeadCont";
import MenuBar from "../../components/common/MenuBar";
import TitleBox from "../../components/common/TitleBox";
import ProgressBar from "../../components/meal/ProgressBar";
import ToggleBar from "../../components/common/ToggleBar";
import InputBox from "../../components/meal/InputBox";
import FoodCard from "../../components/meal/FoodCard";
import FoodInputBox from "../../components/meal/FoodInputBox";
import Btn from "../../components/common/Btn";
import NotEatCard from "../../components/meal/NotEatCard";
import DialogCover from "../../components/common/DialogCover";
import CalendarHeader from "../../components/common/CalendarHeader";
import { saveChosenDate } from "../../../../features/mobile/commonSlice";

const Record = () => {
    const dispatch = useDispatch();
  const navigate = useNavigate();
  dayjs.locale("en");

  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { loginInfo, chosenDate } = useSelector((state) => state.commonApp);
  const { questionsCompleteCheck } = useSelector((state) => state.others);
  const {
    weeklyMealLists,
    weeklyMealStatus,
    chosenDateOfAnalysis,
    existDaysOfYear,
    scrollNum,
  } = useSelector((state) => state.meal);
  const [openModal, setOpenModal] = useState(false);
  const [startDate, setStartDate] = useState(
    dayjs(new Date()).format("YYYY-MM-DD")
  );
  const [status, setStatus] = useState({ option: "show", type: null }); // show: display mode, add: input mode
  const filtered = weeklyMealLists?.filter(
    (list) => list.mealDay === (chosenDate || startDate)
  )[0];

  const sectionRef = useRef([]);
  const datas = [
    { id: 1, mealType: "B", title: "Breakfast" },
    { id: 2, mealType: "BS", title: "Breakfast Snack" },
    { id: 3, mealType: "L", title: "Lunch" },
    { id: 4, mealType: "LS", title: "Lunch Snack" },
    { id: 5, mealType: "D", title: "Dinner" },
    { id: 6, mealType: "DS", title: "Dinner Snack" },
  ];
  console.log(filtered);
  const onSaveAddorEdit = (info) => {
    let params = {
      userId: loginInfo.userId,
      mealType: status.type,
      mealDate: dayjs(chosenDate || startDate).format("YYYY-MM-DD"),
      food: info,
    };
    console.log(params);
    dispatch(addOrEditFood(params))
      .unwrap()
      .then((res) => {
        if (res.ok) {
          let params = {
            userId: loginInfo.userId,
            mealDate: dayjs(chosenDate || startDate).format("YYYY-MM-DD"),
          };
          console.log(params);
          dispatch(searchWeeklyMeal(params));
          dispatch(
            fetchExistDatasOfYear({
              userId: loginInfo.userId,
              year: dayjs(chosenDate || startDate).format("YYYY"),
            })
          );
          setStatus({ option: "show", type: null });
        } else
          toast(
            <p>{res.error}</p>,
            toastCommonProps("bottom-center", "toast_alert", 1000)
          );
      })
      .catch((err) => console.log(err));
  };

  const onSaveNotEat = (type, answer) => {
    let params = {
      userId: loginInfo.userId,
      mealType: type,
      mealDate: dayjs(chosenDate || startDate).format("YYYY-MM-DD"),
      notEat: answer,
    };
    dispatch(addOrEditFood(params))
      .unwrap()
      .then((res) => {
        if (res.ok) {
          let params = {
            userId: loginInfo.userId,
            mealDate: dayjs(chosenDate || startDate).format("YYYY-MM-DD"),
          };
          dispatch(searchWeeklyMeal(params));
          dispatch(
            fetchExistDatasOfYear({
              userId: loginInfo.userId,
              year: dayjs(chosenDate).format("YYYY"),
            })
          );
          setStatus({ option: "show", type: null });
        } else
          toast(
            <p>{res.error}</p>,
            toastCommonProps("bottom-center", "toast_alert", 1000)
          );
      })
      .catch((err) => console.log(err));
  };
  const onDelete = (food) => {
    let params = {
      userId: loginInfo.userId,
      mealType: status.type,
      mealDate: dayjs(chosenDate || startDate).format("YYYY-MM-DD"),
      foodId: food,
    };
    dispatch(deleteFood(params))
      .unwrap()
      .then((res) => {
        if (res.ok) {
          let params = {
            userId: loginInfo.userId,
            mealDate: dayjs(chosenDate || startDate).format("YYYY-MM-DD"),
          };
          dispatch(searchWeeklyMeal(params));
          dispatch(
            fetchExistDatasOfYear({
              userId: loginInfo.userId,
              year: dayjs(chosenDate || startDate).format("YYYY"),
            })
          );
          setStatus({ option: "show", type: null });
        } else
          toast(
            <p>{res.error}</p>,
            toastCommonProps("bottom-center", "toast_alert", 1000)
          );
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (chosenDate > dayjs().format("YYYY-MM-DD")) {
      // Prevent selecting dates after today
      dispatch(saveChosenDate(dayjs().format("YYYY-MM-DD")));
    } else {
      // Fetch weekly meal records for the selected date
      let params = {
        userId: loginInfo.userId,
        mealDate: dayjs(chosenDate || startDate).format("YYYY-MM-DD"),
      };
      dispatch(searchWeeklyMeal(params));
    }
  }, [chosenDate]);

  useEffect(() => {
    if (status.option === "show" && scrollNum) {
      sectionRef.current[scrollNum]?.scrollIntoView({
        behavior: "smooth",
        top: sectionRef.current[scrollNum].offsetTop,
      });
    } else if (status.option !== "show") {
      // Scroll to top when entering add/edit mode
      window.scrollTo(0, 0);
    }
  }, [scrollNum, status.option]);

  useEffect(() => {
    window.scrollTo(0, 0);
    let params = {
      userId: loginInfo.userId,
      year: dayjs(startDate).format("YYYY"),
    };
    dispatch(fetchExistDatasOfYear(params));
  }, [dayjs(startDate).format("YYYY"), chosenDate]);

  return (
    <>
      <HeadCont
        title="Meal Record"
        transparent={"white"}
        onLeftAction={() => navigate(-1)}
        onRightAction={() => navigate("/home")}
        rightIcon={"home"}
      />

      {status.option === "show" ? (
        <>
          <CalendarHeader
            type={"MEAL_RECORD"}
            startDate={startDate}
            setStartDate={setStartDate}
            chosenDate={chosenDate}
            // setChosenDate={setChosenDate}
            existDaysOfYear={existDaysOfYear}
          />

          <div className="-mt-[28px] rounded-tl-[28px] bg-white">
            <div className="border-b border-gray_60 px-6 pb-3 pt-6">
              <TitleBox
                option={6}
                title="Daily Intake vs Goal"
                subTitle={
                  filtered?.eatList?.length === 0 || !filtered?.eatList
                    ? "No records yet"
                    : filtered?.kcal > 0 &&
                      filtered?.needKcal > 0 &&
                      filtered?.kcal >= filtered?.needKcal &&
                      filtered?.proteinG >= filtered?.needProteinG
                    ? "Congratulations! You've reached your goal!"
                    : ""
                }
              />
              <div className="mt-5">
                <div className="flex flex-col gap-2">
                  <ProgressBar
                    title="Calorie Goal"
                    data={filtered?.needKcal}
                    data2={filtered?.kcal}
                    unit={"kcal"}
                    progress={50}
                    bgColor={"bg-[#C9DBFF]"}
                    innerColor={"bg-[#8744E1]"}
                    textColor={"text-white"}
                  />
                  <ProgressBar
                    title="Protein Goal"
                    data={filtered?.needProteinG}
                    data2={filtered?.proteinG}
                    unit={"g"}
                    progress={10}
                    bgColor={"bg-[#ABE7FA]"}
                    innerColor={"bg-[#51CCF3]"}
                    textColor={"text-white"}
                  />
                </div>
              </div>
            </div>
            <ul>
              {datas.map((data, idx) => (
                // Food card by meal type
                <li
                  ref={(el) => (sectionRef.current[idx + 1] = el)}
                  key={data.id}
                  className="flex flex-col gap-3 border-b border-gray_60 p-6"
                >
                  <div className="flex items-center justify-between">
                    <h1 className="text-body2_700 text-black">{data.title}</h1>
                    <div className="flex gap-1">
                      <span className="text-caption1_700 text-black">
                        Did Not Eat
                      </span>
                      <ToggleBar
                        setStatus={setStatus}
                        type={data.mealType}
                        onSaveNotEat={onSaveNotEat}
                        checkStatus={
                          filtered?.eatList?.filter(
                            (eat) => eat.mealType === data.mealType
                          )[0]?.notEat
                        }
                      />
                    </div>
                  </div>
                  {filtered?.eatList.filter(
                    (eat) => eat.mealType === data.mealType
                  )[0]?.notEat ? (
                    <NotEatCard />
                  ) : (
                    <>
                      {filtered?.eatList.filter(
                        (eat) => eat.mealType === data.mealType
                      )[0]?.detailList.length > 0
                        ? filtered?.eatList
                            .filter((eat) => eat.mealType === data.mealType)[0]
                            ?.detailList.map((one, idx) => (
                              <FoodCard
                                key={idx}
                                data={one}
                                type={data.mealType}
                                setStatus={setStatus}
                                onSaveAddorEdit={onSaveAddorEdit}
                                onDelete={onDelete}
                              />
                            ))
                        : null}
                      <InputBox
                        setStatus={setStatus}
                        type={data.mealType}
                        scrollNum={idx + 1}
                      />
                    </>
                  )}
                </li>
              ))}
            </ul>
            <div className="mb-28 p-6">
              <Btn
                id={"mealAnalysis"}
                bgColor={"bg-main"}
                textColor={"text-white font-bold"}
                borderColor={"border border-main"}
                title="Get Meal Analysis"
                active={filtered?.eatList.length > 0 ? "on" : "ready"}
                onAction={() => {
                  if (questionsCompleteCheck.healthComplete) {
                    window.scrollTo(0, 0);
                    navigate(`/meal/analysis/${chosenDate || startDate}`);
                  } else {
                    setOpenModal(true);
                    document.body.style.overflow = "hidden";
                  }
                }}
              />
            </div>
          </div>
        </>
      ) : (
        <div className="min-h-[calc(100vh-80px)] bg-back_ground px-6 pt-20 pb-24">
          <FoodInputBox onSaveAddorEdit={onSaveAddorEdit} />
        </div>
      )}

      {status.option === "show" && <MenuBar />}
      {openModal && (
        <DialogCover
          innerClass={
            "z-50 bg-white rounded-md w-full mx-6 max-[320px]:max-h-[360px] overflow-y-scroll no-scrollbar  shadow-[0_0_12px_rgba(0,0,0,0.1)]"
          }
        >
          <div className="px-4 py-6">
            <h2 className="mb-6 text-subtitle2 text-black">Meal Analysis</h2>
            <div className={"flex w-full items-center gap-2 text-body3_500 "}>
              To view your meal analysis, please complete your health information first.
            </div>
          </div>
          <div className="m-4 flex items-center justify-between gap-2">
            <Btn
              innerClass={"w-fulll w-1/2"}
              bgColor={"bg-white"}
              textColor={"text-main font-semibold"}
              borderColor={"border border-main"}
              title="Cancel"
              active={"on"}
              onAction={() => {
                document.body.style.overflow = "unset";
                setOpenModal(false);
              }}
            />
            <Btn
              innerClass={"w-fulll w-1/2"}
              bgColor={"bg-main"}
              textColor={"text-white font-semibold"}
              borderColor={"border border-main"}
              title="Confirm"
              active={"on"}
              onAction={() => {
                navigate("/question/health");
                document.body.style.overflow = "unset";
                setOpenModal(false);
              }}
            />
          </div>
        </DialogCover>
      )}
    </>
  );
};

export default Record;
